import { useEffect, useRef } from 'react';
import { usePostHog } from 'posthog-js/react';
import { AnalyticsMiddleware } from '../../utils/analytics';

/**
 * Initializes the analytics middleware after PostHog is ready.
 * This component should be placed inside PostHogProvider.
 */
const AnalyticsInitializer = ({ children }) => {
  const posthog = usePostHog();
  const middlewareRef = useRef(null);

  useEffect(() => {
    if (posthog && !middlewareRef.current) {
      middlewareRef.current = new AnalyticsMiddleware(posthog);
      middlewareRef.current.init();
    }
  }, [posthog]);

  return children;
};

export default AnalyticsInitializer;
